import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyFailed } from './components/WhyFailed';
import { MethodREP } from './components/MethodREP';
import { Deliverables } from './components/Deliverables';
import { WhoFor } from './components/WhoFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-paper text-ink font-sans selection:bg-accent/20 selection:text-ink" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Problem data-id="element-3" />
      <WhyFailed data-id="element-4" />
      <MethodREP data-id="element-5" />
      <Deliverables data-id="element-6" />
      <WhoFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Proof data-id="element-9" />
      <Testimonials data-id="element-10" />
      <FAQ data-id="element-11" />
      <OfferBlock data-id="element-12" />
      <Footer data-id="element-13" />
    </main>;
}